var styleBenchmarkLocations = require('./style-benchmark-locations.json');

module.exports = {
  styleBenchmarkLocations: styleBenchmarkLocations
};